import './styles.scss';

import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import IllustrationError from '../../assets/Illustration-error.svg';
import ImmersiveLogo from '../../assets/immersive-logo-dark.svg';
import { darkTheme } from '../../theme/theme';
import Background from '../../widgets/immersive/background/background';

const ErrorPage = () => {
  const handleResetPage = () => {
    window.location.reload();
  };

  return (
    <section className="error-page">
      <ThemeProvider theme={darkTheme}>
        <Background />
        <CssBaseline />
        <div className="header-bar">
          <img src={ImmersiveLogo} alt="Immersive finance" />
        </div>
        <div className="error-page-wrapper">
          <img src={IllustrationError} alt="error" />
          <div className="error-page-content">
            <h1>
              <p>Oops!</p>
            </h1>
            <p className="error-description">
              Something went wrong. Please, refresh the page or try again later.
            </p>

            <Button className="bt-refresh-page" onClick={handleResetPage}>
              <FontAwesomeIcon icon={faArrowRotateRight} />
              <span> Refresh page</span>
            </Button>
          </div>
        </div>
      </ThemeProvider>
    </section>
  );
};

export default ErrorPage;
